export default "__VITE_ASSET__CvoJXQs7__"